import { PDFRaster } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreatePDFRasterArgs,
    getDefaultPDFRasterCreateArgs,
    UpdatePDFRasterArgs,
} from "@nova/serializer/src/client/validators/cubes/pdfRaster"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { selectSingleLayer } from "panels/content/side-panel/slice.new"
import { centroid, maybeSetProjectLocation } from "../projectLocation"

const {
    update: updatePDFRaster,
    delete: deletePDFRaster,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    PDFRaster, // entity type
    CreatePDFRasterArgs, // create args to send to server
    ["id", "filename", "corners", "name", "createdBy"], // create args required by action
    UpdatePDFRasterArgs // update args
>("PDFRaster")

export const addPDFRastersToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data } }) => {
            const optimisticData = {
                ...data,
                ...getDefaultPDFRasterCreateArgs(store.getState().project.data),
            }
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["PDFRasters"],
                })
            )
            const project = store.getState().project.data
            const center = centroid(optimisticData.corners)
            maybeSetProjectLocation(store, project.orgId, project.id, center)

            store.dispatch(selectSingleLayer({ id: data.id }))
        })
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updatePDFRaster(socket, id, updates)
            store.dispatch(updateEntitySocket({ updates, path: ["PDFRasters", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deletePDFRaster(socket, id)
            store.dispatch(deleteEntitySocket({ path: ["PDFRasters", { id }] }))
        })

export {
    createAction as createPDFRaster,
    updateAction as updatePDFRaster,
    deleteAction as deletePDFRaster,
}
